import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

const NonMovingCarsActionTypes = new AbstractApiActionTypes("nonMovingCars");

export default NonMovingCarsActionTypes;
